import { useState } from 'react';
import { cn } from '../../../lib/utils';
import { Tab } from './interface';
import { AllEntriesTab, DangerZoneTab } from './partials';

export function AllEntriesPage() {
  const [activeTab, setActiveTab] = useState<Tab>('entries');

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">All Time Entries</h1>

      <div className="flex gap-1 rounded-lg bg-slate-100 dark:bg-slate-800 p-1 w-fit">
        {(['entries', 'danger'] as const).map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={cn(
              'px-4 py-1.5 rounded-md text-sm font-medium transition-colors',
              activeTab === tab
                ? 'bg-white dark:bg-slate-900 shadow-sm text-slate-900 dark:text-white'
                : 'text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-200',
            )}
          >
            {tab === 'entries' ? 'All Entries' : String.fromCharCode(9888) + ' Danger Zone'}
          </button>
        ))}
      </div>

      {activeTab === 'entries' ? <AllEntriesTab /> : <DangerZoneTab />}
    </div>
  );
}
